import React from 'react';
import { Button } from './Button';
import { scrollToCompra } from '../utils/scroll';
export function ProductShowcase() {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — Fundamentos de la Programación',
    subtitle: 'El origen del pensamiento computacional',
    desc: 'De los algoritmos cotidianos al primer programa en Python. Variables, tipos de datos, input(), print() y pensamiento lógico aplicado a problemas reales.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — Estructuras Básicas',
    subtitle: 'Las decisiones que hacen inteligentes a los programas',
    desc: 'if, elif, else explicados para el siglo XXI. De los semáforos al control de acceso digital. La toma de decisiones en el código.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — Estructuras Repetitivas',
    subtitle: 'El poder de la automatización',
    desc: 'for, while, break y continue conectados con situaciones reales: simuladores, juegos, cálculos. El concepto que hace entender para qué sirve programar.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Funciones y Modularidad',
    subtitle: 'El código profesional empieza aquí',
    desc: 'Diseño de funciones, parámetros, return y el principio DRY. Les enseñamos a pensar en sistemas, no a copiar código.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — Estructuras de Datos',
    subtitle: 'Del dato suelto al sistema completo',
    desc: 'Listas, diccionarios, tuplas y conjuntos. Cómo organizar información real: registros, inventarios, sistemas de votación.'
  }, {
    icon: '📔',
    title: 'Tomo 6 — Aplicaciones Prácticas',
    subtitle: 'Del aprendizaje a la creación',
    desc: 'Cinco proyectos completos: sistema de notas, simulador de banco, juego de trivia, gestor de inventario y mini agenda personal.'
  }];
  return <section className="py-3 md:py-4 px-3 bg-brand-cardAlt border-y border-white/5" data-id="element-109">
      <div className="max-w-5xl mx-auto" data-id="element-110">
        <div className="text-center mb-3" data-id="element-111">
          <h2 className="text-xs md:text-sm font-semibold text-gray-400 mb-1 leading-none uppercase tracking-tight" data-id="element-112">
            🏆 El sistema más completo de planificación para docentes de
            Programación de habla hispana
          </h2>
          <p className="text-lg md:text-2xl font-bold text-white mb-1 uppercase tracking-tight" data-id="element-113">
            📜 KIT COMPLETO PROGRAMACIÓN LISTA
          </p>
          <p className="text-[11px] md:text-xs text-gray-400 font-normal max-w-2xl mx-auto leading-relaxed" data-id="element-114">
            6 tomos organizados progresivamente. 120+ secuencias didácticas
            completas. 4 bonos estratégicos. Todo listo para usar desde hoy.
          </p>
        </div>

        <h3 className="text-center text-white font-semibold mb-2 text-xs md:text-sm uppercase bg-white/5 py-1.5 rounded-xl border border-white/10 tracking-tight" data-id="element-115">
          📘 LOS 6 TOMOS MAESTROS
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-3" data-id="element-116">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-card border border-white/10 rounded-xl p-3 hover:border-white/20 transition-colors group" data-id="element-117">
              <h4 className="text-xs md:text-sm font-semibold text-brand-gold mb-0.5 flex items-start leading-tight" data-id="element-118">
                <span className="mr-1.5" data-id="element-119">{tomo.icon}</span> {tomo.title}
              </h4>
              <p className="text-[10px] md:text-xs text-gray-300 font-medium mb-1 ml-5" data-id="element-120">
                {tomo.subtitle}
              </p>
              <p className="text-[10px] md:text-[11px] text-gray-500 leading-relaxed font-normal ml-5" data-id="element-121">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="w-full max-w-md mx-auto text-center mt-3" data-id="element-122">
          <Button onClick={scrollToCompra} className="text-sm md:text-base py-3 shadow-[0_0_20px_rgba(0,255,136,0.3)] w-full" data-id="element-123">
            🔥 SÍ, QUIERO DEJAR DE IMPROVISAR MIS CLASES
          </Button>
        </div>
      </div>
    </section>;
}